import { render, staticRenderFns } from "./adetectUvSuggest.vue?vue&type=template&id=4e5de6bd&scoped=true&"
import script from "./adetectUvSuggest.vue?vue&type=script&lang=js&"
export * from "./adetectUvSuggest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5de6bd",
  null
  
)

export default component.exports